/**
 * @generated SignedSource<<940a5781b02b1685c1377bc3bf61c284>>
 * @relayHash ac0b73822d0b9a2a6d81fe89301fd584
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a154eed219909c3af8e220d860174ef50589d1ab673a9468775401acd303680a

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GuildDonationScreenContentCreateMutation$variables = {
  amount: number;
  guildId: string;
};
export type GuildDonationScreenContentCreateMutation$data = {
  readonly createPaymentIntent: {
    readonly clientSecret: string | null | undefined;
    readonly feesPayer: string | null | undefined;
    readonly paymentIntentId: string | null | undefined;
  };
};
export type GuildDonationScreenContentCreateMutation = {
  response: GuildDonationScreenContentCreateMutation$data;
  variables: GuildDonationScreenContentCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "amount"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "guildId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "amount",
        "variableName": "amount"
      },
      {
        "kind": "Variable",
        "name": "guildId",
        "variableName": "guildId"
      }
    ],
    "concreteType": "CreatePaymentIntentMutationPayload",
    "kind": "LinkedField",
    "name": "createPaymentIntent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "paymentIntentId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientSecret",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "feesPayer",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "GuildDonationScreenContentCreateMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "GuildDonationScreenContentCreateMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "a154eed219909c3af8e220d860174ef50589d1ab673a9468775401acd303680a",
    "metadata": {},
    "name": "GuildDonationScreenContentCreateMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "8e6b17bf1578543df07ddb130f0bd220";

export default node;
